import AuthManager from './AuthManager'

// returns an authenticated fetch requests if possible
// these method are just shortcuts for including headers into
// fetch requests
const PAGE_LIMIT = 20
export default class FetchHelper {
  static get(endpoint, validateTokens = true) {
    let data = {}
    let statusCode = null

    return AuthManager.setTokens()
      .then(() => {
        data.headers = AuthManager.getHeaders()
        return data
      })
      .then(() => FetchHelper._handleValidateTokens(validateTokens))
      .then(() => fetch(endpoint, data))
      .then(response => {
        statusCode = response.status
        if (statusCode == 204) {
          return response
        }
        return response.json()
      })
      .then(responseJson => {
        let status = { code: statusCode, success: responseJson.status }
        if (this._hasError(status)) {
          throw FetchHelper._getError(responseJson)
          return
        }

        return responseJson
      })
  }

  static post(endpoint, data, isMultiPart = false, validateTokens = true) {
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens)
      .then(() => fetch(endpoint, {
        method: 'POST',
        headers: isMultiPart
          ? AuthManager.getHeaders('multipart/form-data')
          : AuthManager.getHeaders(),
        body: isMultiPart ? data : JSON.stringify(data),
      }))
      .then(response => {
        statusCode = response.status
        if (statusCode == 204) {
          return response
        }
        return response.json()
      })
      .then(responseJson => {
        let status = { code: statusCode, success: responseJson.status }
        if (this._hasError(status)) {
          throw FetchHelper._getError(responseJson)
          return
        }
        return responseJson
      })
  }

  static _handleValidateTokens(validateTokens) {
    if (validateTokens) {
      return AuthManager.validateTokens()
    }

    return new Promise((resolve, reject) => {
      resolve()
    })
  }

  static patch(endpoint, data, stringify = true, validateTokens = true) {
    var headers = AuthManager.getHeaders()
    if (stringify) {
      data = JSON.stringify(data)
    } else {
      headers = AuthManager.getHeaders('multipart/form-data')
    }

    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens)
      .then(() => fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: data
      }))
      .then(response => {
        statusCode = response.status
        if (statusCode == 204) {
          return response
        }
        return response.json()
      })
      .then(responseJson => {
        let status = { code: statusCode, success: responseJson.status }
        if (this._hasError(status)) {
          throw FetchHelper._getError(responseJson)
        }
        return responseJson
      })
  }

  static CCQuery(endpoint, data, website=window.CURRENT_WEBSITE, method="POST", stringify=true){
    let statusCode = null

    let headers = {
      'Content-Type': stringify ? 'application/json' : 'multipart/form-data',
      'funnelReferenceId': website.funnel_reference_id,
    }

    if(endpoint.indexOf("providersApi") > -1){
      if(window.IS_EDIT_MODE) {
        headers['authorization'] = `Bearer ${website.user_token}`
      }else{
        headers['companyToken'] = website.company_token
      }
    }else{
      headers['companyToken'] = website.company_token
      headers['authorization'] = `Bearer ${website.user_token}`
    }

    let requestInit = {
      method: method,
      headers: headers,
      body: stringify ? JSON.stringify(data) : data,
    }

    if(method === "GET"){
      delete requestInit.body
    }

    return fetch(endpoint, requestInit).then(response => {
      statusCode = response.status
      if (statusCode === 204 || statusCode === 401) {
        return response
      }
      return response.json()
    }).then(response => {
      if([
        "Unknown Error",
        "Token/Authorization is needed",
        "No campaigns matching those parameters could be found",
        "Asset does not exist",
        "Error processing CRM response. Response from CRM => no healthy upstream"
      ].includes(response.message)){
        throw response
        return
      }
      return response
    })
  }

  static CCImageUpload(endpoint, data, website=window.CURRENT_WEBSITE, method="POST"){

    let headers = {
      'companyToken': website.company_token,
      'funnelReferenceId': website.funnel_reference_id,
      'authorization': `Bearer ${website.user_token}`
    }

    if(website.user_token){
      delete headers.companyToken
    }

    const xhr = new XMLHttpRequest()
    xhr.open(method, endpoint, true)
    for (const header of Object.keys(headers)) xhr.setRequestHeader(header, headers[header])
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    xhr.send(data)

  }

  static put(endpoint, data, stringify = true, validateTokens = true) {
    var headers = AuthManager.getHeaders()
    if (stringify) {
      data = JSON.stringify(data)
    } else {
      headers = AuthManager.getHeaders('multipart/form-data')
    }
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, {
        // this is needed by server side for all put requests
        method: 'PUT',
        headers: headers,
        body: data
      })
        .then(response => {
          statusCode = response.status
          return response.json()
        })
        .then(responseJson => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
          }

          return responseJson
        })
    })
  }

  static delete(endpoint, data, validateTokens = true) {
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens)
      .then(() => fetch(endpoint, {
        method: 'DELETE',
        headers: AuthManager.getHeaders(),
        body: JSON.stringify(data)
      }))
      .then(response => {
        statusCode = response.status
        if (statusCode == 204) {
          return response
        }
        return response.json()
      })
      .then(responseJson => {
        let status = { code: statusCode, success: responseJson.status }
        if (this._hasError(status)) {
          throw FetchHelper._getError(responseJson)
          return
        }
        return responseJson
      })
  }

  static _hasError({ code, success }) {
    return code < 200 || code > 299 || success == false
  }

  static _getError(responseJson) {
    let error = null
    if (responseJson.message) {
      error = responseJson.message
    } else if (responseJson.non_field_errors) {
      error = responseJson.non_field_errors
    } else {
      error = responseJson
    }

    if (error.constructor == Object) {
      for (var key in error) {
        error = key + ': ' + error[Object.keys(error)[0]]
        break
      }
    }

    let message = 'An unexpected error occured'

    if (error instanceof Array) {
      message = error[0]
    } else if (typeof error === 'string') {
      message = error
    }
    if (error.constructor == Object) {
      for (key in error) {
        message = error[key]
      }
    }

    return { error: error, message: message }
  }

  static _hasMore(results, pageLimit) {
    if (results.current_page) {
      return results.current_page < results.last_page
    }
    return results.data.length >= pageLimit
  }
}
